
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Collapse } from '@components/ui'
import { Layout, SEO } from '@components/common'
import { faqPageQuestions } from '@components/faq/Questions'
import { getMenuCategories } from '@lib/api'
import { sendEvent } from '@lib/tracking'

 async function _getStaticProps() {
  const menuCategories = await getMenuCategories()

  return {
    props: { menuCategories },
  }
}

export default function Faq() {
  const { t } = useTranslation()
  const [activeQuestionIndex, setActiveQuestionIndex] = useState<number | null>(
    -1
  )
  const [activeSection, setActiveSection] = useState<string | null>()

  const handleQuestionClick = (
    section: string,
    index: number,
    questionTitle: string
  ) => {
    if (index === activeQuestionIndex) {
      setActiveQuestionIndex(null)
      setActiveSection(null)
    } else {
      sendEvent({
        event: 'Click_Detail_FAQ',
        data: {
          question: questionTitle,
          page_path: window.location.pathname,
        },
      })
      setActiveQuestionIndex(index)
      setActiveSection(section)
    }
  }

  return (
    <div
      className="max-w-content-xl sm:mx-content-margin-desktop 2lg:relative 2xl:mx-auto flex flex-col"
      id="faq"
    >
      <h1 className="text-4xl font-archivo font-black text-blue ml-4 sm:ml-0 mr-auto">
        {t('faq:faq_title')}
      </h1>

      <div className="flex flex-col mx-4 sm:ml-0 mt-10 lg:mt-28 lg:ml-80 lg:mr-0">
        {faqPageQuestions.map(({ sectionTitle, questions, id }) => (
          <div id={id} key={sectionTitle} className="mb-10 lg:mb-28">
            <h2 className="text-4xl font-archivo font-black text-blue  mb-4">
              {sectionTitle}
            </h2>
            {questions.map((question, index) => (
              <div key={question.title}>
                <Collapse
                  title={question.title}
                  onClick={() =>
                    handleQuestionClick(sectionTitle, index, question.title)
                  }
                  isActive={
                    index === activeQuestionIndex &&
                    sectionTitle === activeSection
                  }
                  noBorder={index === questions.length - 1}
                  withBottomMargin={index !== questions.length - 1}
                >
                  {question.answer}
                </Collapse>
              </div>
            ))}
          </div>
        ))}
      </div>
      <SEO
        title={t('faq:faq_meta_title')}
        description={t('faq:faq_meta_description')}
        openGraph={{
          title: t('faq:faq_og_title'),
          description: t('faq:faq_og_description'),
        }}
      />
    </div>
  )
}

Faq.Layout = Layout


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/faq',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  